<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="商品名称 " prop="goodsName">
                <a-input v-model="queryParam.goodsName" placeholder="请输入商品名称 " @pressEnter="handleQuery" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="商品类型" prop="categoryId">
                <a-select v-model="queryParam.categoryId" placeholder="请选择商品类型">
                  <a-select-option v-for="item in categoryList" :value="item.id" :key=item.id>{{
                    item.categoryName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template >

              <a-col :md="8" :sm="24">
                <a-form-model-item label="状态" prop="status">
                  <a-select v-model="queryParam.status" placeholder="请选择状态">
                    <a-select-option :value="1">上架</a-select-option>
                    <a-select-option :value="0">下架</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>

            </template>
            <a-col :md="(!advanced && 8) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>

              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <!-- <a-button type="primary" @click="$refs.createForm.handleAdd(2)" v-hasPermi="['goods:goodsinfo:add']"> -->
          <a-button type="primary" @click="handleAdd" v-hasPermi="['goods:goodsinfo:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button
          type="primary"
          :disabled="single"
          @click="$refs.createForm.handleUpdate(undefined, ids)"
          v-hasPermi="['goods:goodsinfo:edit']"
        >
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete"
        v-hasPermi="['goods:goodsinfo:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <a-button type="primary" @click="handleWarning()" style="background-color: red; border-color: red">
          <a-icon type="warning" />库存告警
        </a-button>
        <a-button type="primary" :disabled="multiple" @click="batchUpdate(1)" v-hasPermi="['goods:goodsinfo:edit']">
          <a-icon type="edit" />批量上架
        </a-button>
        <a-button type="primary" :disabled="multiple" @click="batchUpdate(0)" v-hasPermi="['goods:goodsinfo:edit']">
          <a-icon type="edit" />批量下架
        </a-button>

      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" @ok="getList" />



      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id" :scroll="{x: 1500,y:'calc(100vh - 400px)'}"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ (current - 1) * size + index + 1 }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="image" slot-scope="text, record">
          <img
            v-viewer
            style="width: 48px; height: 48px; margin-top: 5px; margin-right: 5px"
            v-if="record.picture"
            :src="record.picture"
            preview="头像"
          />
        </span>


        <span slot="status" slot-scope="text, record">
          <a-popconfirm
            ok-text="是"
            cancel-text="否"
            @confirm="confirmStatus(record, record.status)"
            @cancel="cancelStatus(record, record.status)"
          >
            <span slot="title"
              ><b>{{ record.status == 1 ? '是否下架' : '是否上架' }} </b>?</span
            >

            <a-switch checked-children="上架" un-checked-children="下架" :checked="record.status == 1" />
          </a-popconfirm>
        </span>

        <span slot="operation" slot-scope="text, record, index">
            <a @click="handleUpdates(record)" v-hasPermi="['goods:goodsinfo:edit']">

            <a-icon type="edit" />修改
          </a>
          <br>
          <a @click="handleDelete(record, index)" v-hasPermi="['goods:goodsinfo:remove']">
            <a-icon type="delete" :style="{ color: 'red' }" />
            <span class="text-red">删除</span>
          </a>

        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageGoodsInfo, listGoodsInfo, delGoodsInfo, pushWDT, unmount, batchUnmount } from '@/api/goods/goodsInfo'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import TagSelectOption from '@/components/TagSelect/TagSelectOption'
import {listGoodsCategory} from "@/api/goods/goodsCategory";

export default {
  name: 'GoodsInfo',
  components: {
    TagSelectOption,
    CreateForm,
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      categoryList: [],
      // 非多个禁用
      multiple: true,
      ids: [],
      //索引indexs
      indexs: [],
      loading: false,
      total: 0,
      current: 0,
      size: 0,
      // 查询参数
      queryParam: {
        goodsName: null,
        picture: null,
        photoAlbum: null,
        description: null,
        price: null,
        status: null,
        saleAmount: null,
        pageNum: 1,
        pageSize: 10,
      },
      columns: [

        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          align: 'center',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'index' },
        },
        {
          title: 'ID ',
          dataIndex: 'id',
          align: 'center',

        },
        {
          title: '商品名称 ',
          dataIndex: 'goodsName',
          align: 'center',

        },
        {
          title: '主图',
          dataIndex: 'picture',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'image' },
        },

        {
          title: '商品分类',
          dataIndex: 'categoryName',
          ellipsis: true,
          align: 'center'
        },

        {
          title: '状态',
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'status' },
        },

        {
          title: '销量',
          dataIndex: 'saleAmount',
          ellipsis: true,
          align: 'center',
          width:80
        },
        {
          title: '库存',
          dataIndex: 'stock',
          ellipsis: true,
          align: 'center',
          width:80
        },
        {
          title: '评论数',
          dataIndex: 'commentNum',
          ellipsis: true,
          align: 'center',
          width:80,
          scopedSlots: { customRender: 'commentNum' },

        },

        {
          title: '操作',
          dataIndex: 'operation',
          width: 100,
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  filters: {},
  created() {
    this.getList()
    this.initCategory()
  },
  computed: {},
  watch: {},
  methods: {
    handleUpdates(record) {

this.$router.push({ path: '/mall/CreateForms', query: { goodsId: record.id,  "copy":true,codes:1 ,type:2} })
},
handleAdd(){

this.$router.push({ path: '/mall/CreateForms', query: { codes: 0,type:2 } })

},
    /**处理告警显示*/
    handleWarning() {
      this.queryParam.isWarning = 1
      this.getList()
    },
    //我的选品分组
    handleSynWin() {
      this.$refs.synWinGood.handleSynWin()
    },
    viewComment(record) {
      this.$router.push({ path: '/mall/orderComment', query: { goodsId: record.id } })
    },
    viewSku(record) {
      this.$router.push({ path: '/mall/goodsSku', query: { goodsId: record.id } })
    },
    addGoodsSku(record) {
      this.$router.push({ path: '/mall/genate/sku', query: { goodsId: record.id } })
    },
    initCategory() {
      listGoodsCategory().then((res) => {
        this.categoryList = res.data
      })
    },
    confirmStatus(record, status) {
      status = status == 1 ? 0 : 1
      unmount({ id: record.id, status: status,multipleSpecifi:record.multipleSpecifi}).then((res) => {
        if (res.success) {
          this.$message.success('操作成功')
          this.getList()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    batchUpdate(status) {
      batchUnmount({ ids: this.selectedRowKeys, status: status }).then((res) => {
        if (res.success) {
          this.$message.success('操作成功')
          this.getList()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    cancelStatus(record, status) {
      // unmount({id:record.id,status:status}).then(res=>{
      //   if(res.success){
      //     this.$message.success("操作成功")
      //     this.getList()
      //   }else{
      //     this.$message.error(res.message)
      //   }
      // })
    },
    handlePush(record) {
      pushWDT({ id: record.id }).then((res) => {
        if (res.success) {
          this.$message.success('成功')
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /** 查询商品信息列表 */
    getList() {
      this.loading = true
      pageGoodsInfo(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.current = response.data.current
        this.size = response.data.size
        this.loading = false
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.queryParam.isWarning = 0
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        type: 3,
        goodsName: undefined,
        zoneType: undefined,
        categoryId: undefined,
        companyId: undefined,
        goodsCode: undefined,
        picture: undefined,
        photoAlbum: undefined,
        description: undefined,
        price: undefined,
        requireScores: undefined,
        cashCoupon: undefined,
        status: undefined,
        freePostage: undefined,
        freightMoney: undefined,
        limitNum: undefined,
        saleAmount: undefined,
        pageNum: 1,
        pageSize: 10,
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
        // 列表顶部删除indexs
         if(this.selectedRowKeys.length){
        const indexList = this.selectedRowKeys.map(item=>{
          return this.list.findIndex(i=>i.id === item)
        })
        this.indexs = indexList.filter(item=>item!==-1).map(ind=>{
          return (this.current - 1) * this.size + ind + 1
        })
      }
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row,index) {
      var that = this
      const ids = row.id || this.ids
      const inds = (this.current - 1) * this.size + index + 1
      const indexs = inds || this.indexs.sort((a, b) => a - b)
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中序号为' + indexs + '的数据',
        onOk() {
          let data = []
          if(row.id){
                data.push({"id":row.id})
              }else {
                that.ids.map(id => data.push({"id":id}))
              }
          return delGoodsInfo(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {
          //取消清空删除ids列表
          // that.ids = []
        },
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'goods/goods/info/export',
            {
              ...that.queryParam,
            },
            `商品信息_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>
